
//think this full url shouldn't be here like this - better in central place
const IM_PATH:string="https://www.gamestolearnenglish.com/content-5/image-bank/s-140/";

export const ContentFinderItems=function(props:{searchText:string, contentSetDataImsList:string[], itemsMatched:string[][], itemClicked:Function}){
	let items:React.ReactElement[]=[];
    for(let i=0;i<props.itemsMatched.length;i++){
		let imText=props.itemsMatched[i][0];
		let imCode=props.itemsMatched[i][1];
		let isAlreadyUsed=props.contentSetDataImsList.indexOf(imCode)!==-1;
		items.push(<ContentFinderItem imText={imText} imCode={imCode} itemClicked={props.itemClicked} isAlreadyUsed={isAlreadyUsed} key={imCode}/>)
	}
	let showNoMatchesMsg=props.itemsMatched.length===0&&props.searchText.length>0;
	//think okay show notMatchesMsg if also no text matches
	return(
		<div>
			{showNoMatchesMsg&&<p>No images found for "{props.searchText}"</p>}
			<div className="teachers-contentfinder-matchedims">{items}</div>
		</div>
	);
};

const ContentFinderItem=function(props:{imText:string, imCode:string, itemClicked:Function, isAlreadyUsed:boolean}){
	const imSrc=IM_PATH+props.imCode+'.png';
	let itemDisplayName=props.imText;
	return(
		<>
		<div className="teachers-contentfinder-item" onClick={(e)=>props.itemClicked(props.imCode,props.imText)}>
			<div className="teachers-contentfinder-item-imgdiv">
				<img src={imSrc} className="input here" alt="and here"/>
			</div>
			<p>{itemDisplayName}</p>
        	{props.isAlreadyUsed&&<div className="teachers-contentfinder-tickcross"><SVGTick /></div>}
		</div>
		</>
	)
};

const SVGTick = () => {
	return (
	  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
		<circle cx="20" cy="20" r="20" fill="#90CB8B"/>
		<rect x="11.4565" y="18.5728" width="12.547" height="5.49619" rx="1" transform="rotate(44.7905 11.4565 18.5728)" fill="white"/>
		<rect x="13" y="27.1933" width="22.9008" height="5.49619" rx="1" transform="rotate(-45 13 27.1933)" fill="white"/>
	  </svg>
	)
  };